import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FullButtonComponent } from "../shared/ui/full-button/full-button.component";

@Component({
    selector: 'app-page-not-found',
    imports: [FullButtonComponent],
    templateUrl: './page-not-found.component.html',
    styleUrl: './page-not-found.component.css'
})
export class PageNotFoundComponent {
  constructor(private router: Router) {}

  navigateToDashboard() {
    this.router.navigate(['dashboard']);
  }
}
